function getKakao() {
  return (typeof window !== 'undefined') ? window.Kakao : null
}

export function initKakao() {
  const Kakao = getKakao()
  if (!Kakao) throw new Error('kakao_sdk_not_loaded')
  const key = String(process.env.REACT_APP_KAKAO_JS_KEY || '').trim()
  if (!key) throw new Error('kakao_js_key_missing')
  try {
    if (!Kakao.isInitialized()) Kakao.init(key)
  } catch (e) {
    // Kakao SDK 내부에서 throw 할 수 있음
    throw e
  }
}

/** @returns {boolean} true if Kakao share UI was invoked (SDK ok), false if caller should fall back (e.g. clipboard) */
export function tryShareFeedToKakao({ title, description, url }) {
  const linkUrl = String(url || '').trim()
  if (!linkUrl) return false
  const Kakao = getKakao()
  if (!Kakao) return false
  const key = String(process.env.REACT_APP_KAKAO_JS_KEY || '').trim()
  if (!key) return false
  try {
    if (!Kakao.isInitialized()) Kakao.init(key)
  } catch {
    return false
  }
  const imageUrl = String(
    process.env.REACT_APP_KAKAO_SHARE_IMAGE_URL ||
      'https://developers.kakao.com/assets/img/about/logos/kakaolink/kakaolink_btn_medium_ov.png'
  ).trim()
  try {
    Kakao.Share.sendDefault({
      objectType: 'feed',
      content: {
        title: String(title || '설계EZ').slice(0, 200),
        description: String(description || title || '').slice(0, 200),
        imageUrl,
        link: {
          mobileWebUrl: linkUrl,
          webUrl: linkUrl,
        },
      },
    })
    return true
  } catch {
    return false
  }
}

export async function kakaoLogin({ scope = 'account_email' } = {}) {
  initKakao()
  const Kakao = getKakao()
  return await new Promise((resolve, reject) => {
    try {
      Kakao.Auth.login({
        scope,
        success: (authObj) => {
          const token = authObj?.access_token
          if (!token) return reject(new Error('kakao_no_access_token'))
          resolve(String(token))
        },
        fail: (err) => reject(err || new Error('kakao_login_failed')),
      })
    } catch (e) {
      reject(e)
    }
  })
}

